import { useEffect, useRef } from 'react'
import { useMethod } from 'react-method-elements'
import {
    METHOD_FI_AUTHENTICATION_CLOSED,
    METHOD_FI_AUTHENTICATION_ERROR,
    METHOD_FI_AUTHENTICATION_STARTED,
    METHOD_FI_AUTHENTICATION_SUCCESS,
} from '../../analytics/events'
import { useAnalytics } from '../../context/useAnalytics'
import { useUpdateEntityAuthenticationMutation } from '../../graphql/generated/graphql'
import { config } from '../app/config'

type SuccessPayload = {
    accounts: string[]
    authenticated: boolean
    cxn_id: string
    element_type: 'auth'
    entity_id: string
    op: 'success'
}

export const useMethodFiAuthentication = ({
    token,
    onError,
    onCancel,
    onSuccess,
}: {
    token: string
    onError?: () => void
    onCancel?: () => void
    onSuccess?: (accounts: string[]) => void
}) => {
    const opened = useRef(false)
    const succeeded = useRef(false)
    const { trackAnalyticsEvent } = useAnalytics()
    const [updateAuthentication] = useUpdateEntityAuthenticationMutation()

    const method = useMethod({
        env: config.methodFi.env,
        onSuccess: (payload: SuccessPayload) => {
            succeeded.current = true
            trackAnalyticsEvent(METHOD_FI_AUTHENTICATION_SUCCESS, {
                billsConnected: payload.accounts.length,
            })
            updateAuthentication({ variables: { connectionId: payload.cxn_id } })
            onSuccess?.(payload.accounts)
        },
        onError: () => {
            trackAnalyticsEvent(METHOD_FI_AUTHENTICATION_ERROR)
            updateAuthentication()
            onError?.()
        },
        onExit: (event) => {
            console.log('exiting:', event)
            trackAnalyticsEvent(METHOD_FI_AUTHENTICATION_CLOSED)
            if (!succeeded.current) onCancel?.()
        },
        onOpen: () => {
            trackAnalyticsEvent(METHOD_FI_AUTHENTICATION_STARTED)
        },
    })

    useEffect(() => {
        if (!method || opened.current) return
        method.open(token)
        opened.current = true
    }, [method, token])
}
